// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import {Panel} from '@pub/comp/panel';
import {Page} from '@pub/comp/page';
import {Text} from '@pub/comp/text';
import {Button} from '@pub/comp/button';
import {DASHBOARD_DISABLED, FAQ_LINK} from '@pub/utils/constants.js';
import maintenance_url from '@pub/img/maintenance.svg?url';
import './maintenance.less';

const messages = [
    DASHBOARD_DISABLED?.message,
    'We will be back in a few hours, thanks for your patience',
].filter(Boolean);

export function Maintenance(){
    return <Page className="ea_maintenance" headerless sidebarless>
      <Panel className="eam_wrapper">
        <div className="ea_logo eam_logo"/>
        <Text.xl h1 className="eam_title">
          EarnApp dashboard is currently down for maintenance
        </Text.xl>
        <ul className="eam_messages">
          {messages.map(m=><li key={m} className="eam_message">{m}</li>)}
        </ul>
        <img className="eam_image" src={maintenance_url}/>
        <footer className="eam_footer">
          <Button href="/">Homepage</Button>
          <Button href={FAQ_LINK}>FAQ</Button>
        </footer>
      </Panel>
    </Page>;
}
